
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-gpk/pegawai/pelaksanaan/praktik-kinerja/observasi-rencana-tindak-lanjut",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-gpk/pegawai/pelaksanaan/praktik-kinerja/observasi-rencana-tindak-lanjut.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-gpk/pegawai/pelaksanaan/praktik-kinerja/observasi-rencana-tindak-lanjut"])
      });
    }
  